import PropTypes from "prop-types";
import React from "react";
import Markdown from "../Markdown";
import Link from "../Link";
import CustomImage from "../CustomImage";
import { Box, Heading } from "rebass/styled-components";

const VerticalCard = ({ picto, title, content, image, link, linklabel, onClick }) => {
  const hasLinnk = link !== null && link !== "" && linklabel !== null && linklabel !== "";
  const isClickable = typeof onClick === "function";

  if (image) {
    return (
      <Box
        width={1}
        height="300px"
        onClick={isClickable ? onClick : undefined}
        sx={{
          position: "relative",
          overflow: "hidden",
          borderRadius: "4px",
          cursor: isClickable ? "pointer" : "default",
          "&:hover .card-image": {
            transform: "scale(1.15)"
          },
          "&:hover .card-title": {
            color: "#E1AF11"
          }
        }}
      >
        <Box
          className="card-image"
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: `url(${
              typeof image === "string" ? image : image.childImageSharp.fluid.src
            })`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            transition: "transform 0.9s ease"
          }}
        />
        <Box
          sx={{
            position: "absolute",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            background:
              "linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.2) 50%, rgba(0,0,0,0) 100%)",
            zIndex: 1
          }}
        />
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            paddingLeft: "10px",
            paddingBottom: "10px",
            color: "white",
            zIndex: 2
          }}
        >
          {title && (
            <Heading
              as="h3"
              className="card-title"
              sx={{
                color: "white",
                fontSize: 3,
                fontFamily: "Poppins, sans-serif",
                fontWeight: "600",
                transition: "color 0.3s ease"
              }}
            >
              {title}
            </Heading>
          )}
          {content && (
            <Box
              sx={{
                color: "white",
                fontSize: 1,
                mt: 2,
                opacity: 0.9,
                display: "none" // Hidden by default, could be shown on hover if needed
              }}
            >
              <Markdown>{content}</Markdown>
            </Box>
          )}
          {hasLinnk && (
            <Box py={2} width={[1]}>
              <Link
                href={link}
                sx={{
                  color: "white",
                  textDecoration: "underline",
                  "&:hover": {
                    color: "#E1AF11"
                  }
                }}
              >
                {linklabel}
              </Link>
            </Box>
          )}
        </Box>
      </Box>
    );
  }
  // Case without image
  return (
    <Box
      width={1}
      height="300px"
      onClick={isClickable ? onClick : undefined}
      sx={{
        position: "relative",
        backgroundColor: "#645546",
        borderRadius: "4px",
        overflow: "hidden",
        cursor: isClickable ? "pointer" : "default",
        "&:hover .card-title": {
          color: "#E1AF11"
        }
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          background:
            "linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.2) 50%, rgba(0,0,0,0) 100%)",
          zIndex: 1
        }}
      />
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          paddingLeft: "10px",
          paddingBottom: "10px",
          color: "white",
          zIndex: 2
        }}
      >
        {picto && (
          <Box maxWidth="50px" maxHeight="50px" mb={2}>
            <CustomImage img={picto} />
          </Box>
        )}
        {title && (
          <Heading
            as="h3"
            className="card-title"
            sx={{
              color: "white",
              fontSize: 3,
              fontFamily: "Poppins, sans-serif",
              fontWeight: "600",
              transition: "color 0.3s ease"
            }}
          >
            {title}
          </Heading>
        )}
        {content && (
          <Box
            mt={1}
            sx={{
              color: "white",
              fontSize: 1,
              opacity: 0.9,
              display: "none" // Hidden by default
            }}
          >
            <Markdown>{content}</Markdown>
          </Box>
        )}
        {hasLinnk && (
          <Box py={1} width={[1]}>
            <Link
              href={link}
              sx={{
                color: "white",
                textDecoration: "underline",
                "&:hover": {
                  color: "#E1AF11"
                }
              }}
            >
              {linklabel}
            </Link>
          </Box>
        )}
      </Box>
    </Box>
  );
};

VerticalCard.propTypes = {
  content: PropTypes.any,
  image: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      childImageSharp: PropTypes.shape({
        fluid: PropTypes.object
      })
    })
  ]),
  link: PropTypes.string,
  linklabel: PropTypes.string,
  picto: PropTypes.any,
  title: PropTypes.string,
  onClick: PropTypes.func
};

export default VerticalCard;
